export default __webpack_public_path__ + "static/media/jumbox-brand.a257155a.png";